import React from 'react';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import { isInboxItemAnnouncement } from '../../lib/announcements';
import { notificationSenderLabel } from '../../lib/notificationRouting';

/**
 * In-place overlay for company broadcasts and CRM-style alerts (no navigation).
 * @param {{
 *   open: boolean,
 *   item: object | null,
 *   createdAt?: Date | null,
 *   onClose: () => void,
 * }} props
 */
export default function NotificationMessageModal({ open, item, createdAt, onClose }) {
  if (!item) return null;

  const isBroadcast = isInboxItemAnnouncement(item);
  const sender = notificationSenderLabel(item);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth aria-labelledby="notification-message-title">
      <DialogTitle id="notification-message-title" sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 6 }}>
        {isBroadcast ? <CampaignIcon color="primary" /> : null}
        <Typography component="span" variant="h6" sx={{ fontWeight: 700 }}>
          {item.title || 'Message'}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5}>
          <Stack direction="row" flexWrap="wrap" gap={1} alignItems="center">
            {isBroadcast && (
              <Chip size="small" label="Company broadcast" color="primary" variant="outlined" />
            )}
            {item.severity && !isBroadcast && (
              <Chip size="small" label={item.severity} variant="outlined" />
            )}
          </Stack>
          <Typography variant="body2" color="text.secondary">
            From <strong>{sender}</strong>
            {createdAt ? ` · ${createdAt.toLocaleString()}` : ''}
          </Typography>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
            {item.message || 'No message provided.'}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
